import { ReactComponent as AddUserReport } from "@assets/icons/add_user_icon.svg";

const AddUserReportIcon = (props: any): JSX.Element => {
  return (
    <AddUserReport
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default AddUserReportIcon;
